import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllCustomers = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/customers',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveCustomer = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/customers',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateCustomer = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/customers/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteCustomer = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/customers/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllCustomers,
  saveCustomer,
  deleteCustomer,
  updateCustomer,
}
